import React from 'react'
import ReactSelect from '../../components/Inputs/ReactSelect'

function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id, Header },
}) {
  // Calculate the options for filtering
  // using the preFilteredRows
  const options = React.useMemo(() => {
    const options = []
    preFilteredRows.forEach(row => {
      if (options.find(item => item.value === row.values[id])) {
        return;
      } else {
        return options.push({
          value: row.values[id],
          label: row.values[id],
        })
      }
    })
    return [...options]
  }, [id, preFilteredRows])

  // Render a multi-select box
  return (
    <ReactSelect
      label={Header}
      value={filterValue}
      onChange={e => {
        setFilter(e.value || undefined)
      }}
      options={options}
    />
  )
}

export default SelectColumnFilter
